import gtfy from '@/page/gtfy'
import Home from '@/page/Home'
import Homet from '@/page/Homet'
import portal from '@/page/portal'
import syxw from '@/page/syxw'
import wwnry from '@/page/wwnry'
import xyjj from '@/page/xyjj'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'Homet',
      component: Homet,
      redirect: '/portal',
      children: [{
        path: '/portal',
        name: 'portal',
        component: portal
      }]
    }, {
      path: '/Home',
      name: 'Home',
      component: Home,
      children: [{
        path: '/xygk/xyjj',
        name: 'xyjj',
        component: xyjj
      },{
        path: '/portal',
        name: 'portal',
        component: portal
      }, {
        path: '/gtfy',
        name: 'gtfy',
        component: gtfy
      }, {
        path: '/wwnry',
        name: 'wwnry',
        component: wwnry
      }, {
        path: '/xygk',
        name: 'xygk',
        component: xyjj,
        redirect: '/xyjj',
        children: [ {
          path: '/xygk/syls',
          name: 'syls',
          component: xyjj
        }, {
          path: '/xygk/xrld',
          name: 'xrld',
          component: xyjj
        }, {
          path: '/xygk/xyfg',
          name: 'xyfg',
          component: xyjj
        }, {
          path: '/xygk/dlwz',
          name: 'dlwz',
          component: xyjj
        }]
      },
      {
        path: '/jgdj',
        // 机关党建
        name: 'jgdj',
        component: syxw,
        redirect: '/syxw',
        children:[{
            path:'/jgdj/djxw',
            name:'djxw',
            component:syxw
          }]
        },
       {
        path:'/yjs',
        // 机关党建
        name: 'yjs',
        component: syxw,
        redirect: '/syxw',
        children: [{
          path: '/yjs/yjsxx',
          name: 'yjsxx',
          component: syxw
        }]
      },
      {
        path: '/xwzx',
        name: 'xwzx',
        component: syxw,
        redirect: '/syxw',
        children: [{
          path: '/xwzx/syxw',
          name: 'syxw',
          component: syxw
        }, {
          path: '/xwzx/tzgg',
          name: 'tzgg',
          component: syxw
        }, {
          path: '/xwzx/tzyw',
          name: 'tzyw',
          component: syxw
        }, {
          path: '/xwzx/sxxw',
          name: 'sxxw',
          component: syxw
        }]
      },
      {
        path: '/jxpx',
        name: 'jxpx',
        component: syxw,
        redirect: '/syxw',
        children: [{
          path: '/jxpx/jxxx',
          name: 'jxxx',
          component: syxw
        }, {
          path: '/jxpx/jxyj',
          name: 'jxyj',
          component: syxw
        }, {
          path: '/jxpx/zzjs',
          name: 'zzjs',
          component: syxw
        }, {
          path: '/jxpx/jzjs',
          name: 'jzjs',
          component: syxw
        }, {
          path: '/jxpx/jwgl',
          name: 'jwgl',
          component: syxw
        }, {
          path: '/jxpx/dwpx',
          name: 'dwpx',
          component: syxw
        }]
      }, {
        path: '/kyzk',
        name: 'kyzk',
        component: syxw,
        redirect: '/syxw',
        children: [{
          path: '/kyzk/kydt',
          name: 'kydt',
          component: syxw
        }, {
          path: '/kyzk/kygl',
          name: 'kygl',
          component: syxw
        }, {
          path: '/kyzk/kycg',
          name: 'kycg',
          component: syxw
        }]
      }, {
        path: '/tzll',
        name: 'tzll',
        component: syxw,
        redirect: '/syxw',
        children: [{
          path: '/tzll/jdls',
          name: 'jdls',
          component: syxw
        }, {
          path: '/tzll/tzzc',
          name: 'tzzc',
          component: syxw
        }, {
          path: '/tzll/tzwx',
          name: 'tzwx',
          component: syxw
        }]
      },, {//研究动态
        path: '/yjdt',
        name: 'yjdt',
        component: syxw,
        redirect: '/syxw',
        redirect: '/xyjj',
        children: [{
          path: '/yjdt/czdjsyjzx/zxxx',
          name: 'zxxx',
          component: syxw
        }, {
          path: '/yjdt/czdjsyjzx/czdyjwx',
          name: 'czdwx',
          component: syxw
        }, {
          path: '/yjdt/czdjsyjzx/qtyjzl',
          name: 'yjzl',
          component: syxw
        }, {
          path: '/yjdt/czdjsyjzx/alk',
          name: 'ajk',
          component: syxw
        },{
          path: '/yjdt/fgyzjjzx/zxxx',
          name: 'zxxx',
          component: syxw
        }, {
          path: '/yjdt/fgyzjjzx/yjzl',
          name: 'czdwx',
          component: syxw
        }, {
          path: '/yjdt/fgyzjjzx/ajk',
          name: 'yjzl',
          component: syxw
        },{
          path: '/yjdt/mzyzjzx/zxxx',
          name: 'zxxx',
          component: syxw
        }, {
          path: '/yjdt/mzyzjzx/yjzl',
          name: 'czdwx',
          component: syxw
        }, {
          path: '/yjdt/mzyzjzx/ajk',
          name: 'yjzl',
          component: syxw
        },{
          path: '/yjdt/zhwhzx/zxxx',
          name: 'zxxx',
          component: syxw
        }, {
          path: '/yjdt/zhwhzx/yjzl',
          name: 'czdwx',
          component: syxw
        }, {
          path: '/yjdt/zhwhzx/ajk',
          name: 'yjzl',
          component: syxw
        }]
      }, {
        path: '/yjdt/czdjsyjzx/zxgk',
        name: 'czdjsyjzx',
        component: xyjj,
        children: [{
          path: '/yjdt/czdjsyjzx/zxgk',
          name: 'zxgk',
          component: xyjj
        }]
      }, {
        path: '/yjdt/fgyzjjzx/zxgk',
        name: 'fgyzjjzx',
        component: xyjj,
        children: [{
          path: '/yjdt/fgyzjjzx/zxgk',
          name: 'zxgk',
          component: xyjj
        }]
      }, {
        path: '/yjdt/mzyzjzx/zxgk',
        name: 'mzyzjzx',
        component: xyjj,
        children: [{
          path: '/yjdt/mzyzjzx/zxgk',
          name: 'zxgk',
          component: xyjj
        }]
      },{
        path: '/yjdt/zhwhzx/zxgk',
        name: 'zhwhzx',
        component: xyjj,
        children: [{
          path: '/yjdt/zhwhzx/zxgk',
          name: 'zxgk',
          component: xyjj
        }]
      }, {
        path: '/whjl',
        name: 'whjl',
        component: syxw,
        redirect: '/syxw',
        redirect: '/xyjj',
        children: [{
          path: '/whjl/xydt',
          name: 'xydt',
          component: syxw
        }, {
          path: '/whjl/zjwh',
          name: 'zjwh',
          component: syxw
        }, {
          path: '/whjl/zhwh',
          name: 'zhwh',
          component: syxw
        }]
      }, {
        path: '/whjl',
        name: 'whjl',
        component: xyjj,
        children: [{
          path: '/whjl/xyjj',
          name: 'xyjj',
          component: xyjj
        }]
      }, {
        path: '/zl',
        name: 'zl',
        component: xyjj,
        children: [{
          path: '/zl/jjzjdjblxfs',
          name: 'jjzjdjblxfs',
          component: xyjj
        }]
      },
      {
        path: '/zt',
        name: 'zt',
        component: syxw,
        children: [{
          path: '/zt/*',
          name: 'zt',
          component: syxw
        }]
      },
      //参政党建设研究中心
      {
        path: '/czdzx',
        name: 'czdzx',
        component: syxw,
        redirect: '/syxw',
        redirect: '/xyjj',
        children: [{
          path: '/czdzx/zxxx',
          name: 'zxxx',
          component: syxw
        }, {
          path: '/czdzx/czdwx',
          name: 'czdwx',
          component: syxw
        }, {
          path: '/czdzx/yjzl',
          name: 'yjzl',
          component: syxw
        }, {
          path: '/czdzx/ajk',
          name: 'ajk',
          component: syxw
        }]
      }, {
        path: '/czdzx',
        name: 'czdzx',
        component: xyjj,
        children: [{
          path: '/czdzx/zxgk',
          name: 'zxgk',
          component: xyjj
        }]
      },
      //非公有制经济两个健康研究中心
      {
        path: '/fgyzjjzx',
        name: 'fgyzjjzx',
        component: syxw,
        redirect: '/syxw',
        redirect: '/xyjj',
        children: [{
          path: '/fgyzjjzx/zxxx',
          name: 'zxxx',
          component: syxw
        }, {
          path: '/fgyzjjzx/yjzl',
          name: 'yjzl',
          component: syxw
        }, {
          path: '/fgyzjjzx/ajk',
          name: 'ajk',
          component: syxw
        }]
      }, {
        path: '/fgyzjjzx',
        name: 'fgyzjjzx',
        component: xyjj,
        children: [{
          path: '/fgyzjjzx/zxgk',
          name: 'zxgk',
          component: xyjj
        }]
      },
      //民族与宗教研究中心
      {
        path: '/mzyzjzx',
        name: 'mzyzjzx',
        component: syxw,
        redirect: '/syxw',
        redirect: '/xyjj',
        children: [{
          path: '/mzyzjzx/zxxx',
          name: 'zxxx',
          component: syxw
        }, {
          path: '/mzyzjzx/yjzl',
          name: 'yjzl',
          component: syxw
        }, {
          path: '/mzyzjzx/ajk',
          name: 'ajk',
          component: syxw
        }]
      }, {
        path: '/mzyzjzx',
        name: 'mzyzjzx',
        component: xyjj,
        children: [{
          path: '/mzyzjzx/zxgk',
          name: 'zxgk',
          component: xyjj
        }]
      },
      //中华文化研究中心
      {
        path: '/zhwhzx',
        name: 'zhwhzx',
        component: syxw,
        redirect: '/syxw',
        redirect: '/xyjj',
        children: [{
          path: '/zhwhzx/zxxx',
          name: 'zxxx',
          component: syxw
        }, {
          path: '/zhwhzx/yjzl',
          name: 'yjzl',
          component: syxw
        }, {
          path: '/zhwhzx/ajk',
          name: 'ajk',
          component: syxw
        }]
      }, {
        path: '/zhwhzx',
        name: 'zhwhzx',
        component: xyjj,
        children: [{
          path: '/zhwhzx/zxgk',
          name: 'zxgk',
          component: xyjj
        }]
      }, {
        path: '/tsg',
        name: 'tsg',
        component: syxw,
        redirect: '/syxw',
        redirect: '/xyjj',
        children: [{
          path: '/tsg/tsjs',
          name: 'tsjs',
          component: syxw
        }]
      }, {
        path: '/tsg',
        name: 'tsg',
        component: xyjj,
        children: [{
          path: '/tsg/bygk',
          name: 'bygk',
          component: xyjj
        }, {
          path: '/tsg/szzy',
          name: 'szzy',
          component: xyjj
        }]
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js